<template>
  <div>
    <div class="orders-top-wrapper">
      <orders-top-left></orders-top-left>
      <notifications></notifications>
      <orders-top-right></orders-top-right>
    </div>
    <div class="orders-middle">
      <orders-table :order-dates="orderDates"></orders-table>
      <orders-calendar :selected-main-tab="'orders'" @order_date="setOrderDate"></orders-calendar>
    </div>
    <div class="orders-bottom-wrapper">
      <orders-bottom-left></orders-bottom-left>
      <div class="tempLikeViki"></div>
      <security-cams></security-cams>
    </div>
  </div>
</template>

<script>
import moment from "moment/moment";
import {mapGetters, mapState} from "vuex";

import OrdersTable from "./OrdersTable";
import OrdersTopLeft from "../graphs/top/OrdersTopLeft"
import OrdersTopRight from "../graphs/top/OrdersTopRight"
import OrdersBottomLeft from "../graphs/bottom/OrdersBottomLeft"
// import OrdersBottomRight from "../graphs/bottom/OrdersBottomRight"
import OrdersCalendar from "../components/Calendar/OrdersCalendar";
import Notifications from "../../../msg_center.feature/containers/Notifications.component";
import apiClientCreator from "../../../../helpers/api/request";
import UsersPermissionCheck from "../../../../mixins/user/auth/UsersPermissionCheck";
import SecurityCams from "../../../security.feature/containers/SecurityCams.container";


export default {
  name: "MainOrdersContainer",
  props: {},
  components: {
    OrdersTable,
    OrdersTopLeft,
    OrdersTopRight,
    OrdersBottomLeft,
    // OrdersBottomRight,
    OrdersCalendar,
    Notifications,
    SecurityCams,
  },
  mixins: [UsersPermissionCheck],
  data() {
    return {
      orderDates:{}
    }
  },
  computed: {
    ...mapState("user", ["auth"]),
    ...mapGetters("user", ["isLogged"]),
    ...mapState("clients", ["loading", "dictionaries"]),
    ...mapGetters("main", ["showVikiMsg"]),
    ...mapState("main", ["showVikiMsg"])
  },

  methods:{
    setOrderDate(data){
      this.orderDates = data
    }
  }
}
</script>

<style scoped>
.orders-top-wrapper {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}

.orders-bottom-wrapper {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}

.tempLikeViki {
  min-width: calc(10%);
  max-width: calc(10%);
  margin-bottom: 30px;
  max-height: 100%;
}
</style>